// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header__title":"Header_header__title__zG0D0"};